// DS: Indicators / 1.7.1
import React from 'react';
import c from 'classnames';
import s from './NotificationCounter.scss';
const NotificationCounter = ({ children , className  })=>/*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, children);
NotificationCounter.displayName = 'NotificationCounter';
export default NotificationCounter;
